import { Select, SelectProps } from 'antd';
import { useRef, useState } from 'react';
import { StyledTag } from '../ImplementData/components/Filter/DepartmentSelect';
import { useUpdateEffect } from 'ahooks';

function SearchSelect<T>({
  value: valueProp,
  onChange: onChangeProp,
  onBlur,
  ...otherProps
}: Omit<SelectProps<T[]>, 'onChange'> & {
  onChange: (value: T[]) => void;
}) {
  const [value, setValue] = useState(valueProp);

  const refsCurrent = { valueProp, onChangeProp, value };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useUpdateEffect(() => {
    if (valueProp !== refs.current.value) {
      setValue(valueProp);
    }
  }, [valueProp]);

  return (
    <Select
      className="w-48"
      allowClear
      showSearch
      dropdownMatchSelectWidth={false}
      mode="multiple"
      maxTagCount="responsive"
      value={value}
      onChange={setValue}
      onBlur={(e) => {
        if (value !== valueProp) {
          onChangeProp(value || []);
        }

        if (onBlur) {
          onBlur(e);
        }
      }}
      onClear={() => {
        onChangeProp([]);
      }}
      tagRender={({ label }) => <StyledTag>{label}</StyledTag>}
      optionFilterProp="label"
      {...otherProps}
    />
  );
}

export default SearchSelect;
